export const makeCommand = (instruction) => {
    return `<${instruction}>`;
};
export const makeCommandFromAttributes = (attributes) => {
    const str = attributes
        .map(attribute => {
        if (typeof attribute === 'number') {
            return attribute.toString();
        }
        return attribute;
    })
        .filter(attribute => !isBlank(attribute))
        .join(' ');
    return makeCommand(str);
};
function isBlank(param) {
    if (typeof param === 'string') {
        return param.trim() === '';
    }
    return true;
}
